import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-shipping-guide';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay Shipping Guide for Sellers</title>
        <meta
          name='description'
          content='Avoid making shipping mistakes at eBay and know the best shipping practices to minimize returns!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-shipping-guide' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-shipping-guide' />
        <meta property='og:title' content='eBay Shipping Guide for Sellers' />
        <meta
          property='og:description'
          content='Avoid making shipping mistakes at eBay and know the best shipping practices to minimize returns!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
